import React from "react";
import { Vortex } from "react-loader-spinner";

interface GradientButtonProps {
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  text?: string | React.ReactNode; // <-- Allow both string and JSX
  onClick?: () => void;
  className?: string;
  paddingX?: string;
  paddingY?: string;
  width?: string;
  fontSize?: string;
  fontWeight?: string
  gradient?: string;
  Icon?: React.ElementType;

}

export default function GradientButton({
  type = "button",
  disabled = false,
  loading = false,
  text,
  onClick,
  className = "",
  paddingX = "px-4",
  paddingY = "py-2",
  width = "",
  fontSize = "",
  fontWeight = "font-semibold",
  gradient,
  Icon
}: GradientButtonProps) {
  return (
    <button
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
      className={`group rounded-full ${gradient ? `${gradient}` : "bg-gradient-to-r from-[#237249] to-[#35C66B]"}
         text-white
        duration-300 ease-in-out
        hover:-translate-y-2
        hover:shadow-[0_8px_20px_0_#35C66B4d] 
        disabled:opacity-60 disabled:cursor-not-allowed
        ${paddingX} ${paddingY} ${width} ${fontSize} ${fontWeight} ${className}`}
    >

      {loading ? (
        <div className="flex justify-center items-center">
          <Vortex
            visible={true}
            height={30}
            width={30}
            ariaLabel="vortex-loading"
            colors={["white", "white", "white", "white", "white", "white"]}
          />
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          {Icon && <Icon className="w-5 h-5" />}
          {text ?? "Button"}
        </div>
      )}

    </button>
  );
}
